import { GlobalComposable } from "~/classes/composable/GlobalComposable"

class Alerts extends GlobalComposable<{
  alerts: Record<string, AlertNotification>
}> {
  override defaultState = () => ({
    alerts: {},
  })

  notify = (notification: AlertNotification) => {
    const { showNotificationAnimations } = useNotificationTray()
    this.state.value.alerts[notification.transferId] = notification
    // TODO: only show a "peek" view of the tray

    showNotificationAnimations()
  }

  notifySuccess = (title: string, description: string) => {
    const { showNotificationAnimations } = useNotificationTray()
    const message: SuccessAlertNotification = {
      type: "success-alert",
      transferId: generateWorkerRequestId(),
      timestamp: Date.now(),
      title,
      description,
    }
    this.state.value.alerts[message.transferId] = message
    showNotificationAnimations()
    return message
  }

  notifyError = (title: string, description: string) => {
    const { showNotificationAnimations } = useNotificationTray()
    const error: ErrorAlertNotification = {
      type: "error-alert",
      errorType: "generic",
      transferId: generateWorkerRequestId(),
      timestamp: Date.now(),
      title,
      description,
    }
    this.state.value.alerts[error.transferId] = error
    showNotificationAnimations()
    return error
  }

  notifyDatagramError = ({ type: _, details }: DatagramError, title?: string) => {
    const { showNotificationAnimations } = useNotificationTray()
    const error: ErrorAlertNotification = {
      type: "error-alert",
      errorType: "generic",
      transferId: generateWorkerRequestId(),
      timestamp: Date.now(),
      title: title || "An error occurred",
      description: details,
    }
    this.state.value.alerts[error.transferId] = error
    showNotificationAnimations()
    return error
  }

  clearAlert = (transferId: string) => {
    delete this.state.value.alerts[transferId]
  }

  clearAllAlerts = () => {
    this.state.value.alerts = {}
  }
}

const alerts = new Alerts("alerts", theme.colors.amber.hex)

export default function () {
  return alerts.use()
}
